export default __webpack_public_path__ + "static/media/icon-error.09546790.svg";